
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ObjectType, SportCompetitionV2 } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import CompetitionLogo from '@/components/sports/common/competition/logos/CompetitionLogo.vue';

@Component({ name: 'CompetitionCard', components: { CompetitionLogo } })
export default class CompetitionCard extends Vue {
	@Prop() competition: SportCompetitionV2;

	get competitionName() {
		return this.competition?.content?.name;
	}

	handleCompetitionClick() {
		const sportContext = new SnowplowSportContext(this.competition.sport, ObjectType.SportCompetition);
		sportContext.competitionId = this.competition.objectId;

		TrackingHelper.trackEvent(
			'userinteraction',
			{ action: 'competition_clicked', property: 'icon', useLastRoute: true },
			[sportContext]
		);
	}
}
